import React, {useState} from "react";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash";

import Row from "../../../../Common/Row";
import Loader from "../../../../Common/Loader";
import Actions from "../../../../../store/actions/customerActions";
import {handle} from "../../../../../common/responseHandler";
import Tools from "../../../../../helpers/tools";

const Rows = ({order}) => {
    const details = _.get(order, `details.orderDetails`, {});
    const currentStatus = _.get(order, `details.currentStatus.currentStatus`);
    return (
        <>
            <Row label={`Brand`} value={details.brand}/>
            <Row label={`Engine`} value={details.engine}/>
            <Row label={`Transmission`} value={details.transmission}/>
            <Row label={`Color`} value={details.vehicleExternalColor}/>
            <Row label={`Model`} value={details.vehicleModel}/>
            <Row label={`Order status`} value={Tools.orderToLabel(currentStatus)}/>
            <Row label={`Last location`} value={_.get(order, `details.lastLocation`)}/>
        </>
    );
};

const Order = ({customer, order, showOrderId}) => {
    const dispatch = useDispatch();
    const isLoading = useSelector(state => state.loader);
    const [open, setOpen] = useState(false);
    const isComplete = _.get(order, `isComplete`);

    const togglePanel = () => {
        if (customer.uuid && !order.details && !open) {
            dispatch(Actions.getOrderDetails(customer.uuid, order.id)).catch(handle);
        }
        setOpen(!open);
    };

    return (
        <table className="table" id="accordion">
            <thead>
            <tr>
                <th colSpan={2}>
                    <span>{`${showOrderId ? `${order.id} - ` : ``}${order.alias}`}</span>
                    <span
                        className={`${isComplete ?
                            `glyphicon glyphicon-eye-close customer-not-owner` :
                            `glyphicon glyphicon-eye-open customer-owner`}`
                        }
                        aria-hidden="true"
                        title={`${isComplete ?
                            `This VOT order is not visible anymore to the customer as it has been completed` :
                            `This VOT order is visible to the customer`}`
                        }
                    />
                    <span
                        onClick={togglePanel}
                        className={`clickable fa ${open ? `fa-chevron-up` : `fa-chevron-down`} float-right`}
                        aria-hidden="true"
                    />
                </th>
            </tr>
            </thead>
            <tbody className={open ? `` : `hidden`}>
            {
                _.get(order, `hasOrderDetailsLoaded`) || (_.get(order, `hasOrderDetailsFailed`) && !isLoading) ?
                    <Rows order={order}/> : <Loader relative/>
            }
            </tbody>
        </table>

    );
};

Rows.displayName = `Rows`;
Rows.propTypes = {
    order: PropTypes.object.isRequired
};
Order.displayName = `Order`;
Order.propTypes = {
    customer: PropTypes.object.isRequired,
    order: PropTypes.object.isRequired,
    showOrderId: PropTypes.bool
};

export default Order;
